module.exports = __webpack_public_path__ + "static/media/shantanu.4c27a976.png";